import { fromJS } from 'immutable';

import {
	FETCH_PATIENT_ROIS,
	FETCH_PATIENT_ROIS_SUCCESS,
	FETCH_PATIENT_ROIS_ERROR,
	REVOKE_PATIENT_ROI,
	REVOKE_PATIENT_ROI_SUCCESS,
	REVOKE_PATIENT_ROI_ERROR,
	RENEW_PATIENT_ROI,
	RENEW_PATIENT_ROI_SUCCESS,
	RENEW_PATIENT_ROI_ERROR,
} from './constants';

export const initialState = fromJS({
	rois: [],
	loading: false,
	revoking: false,
	renewing: false,
	error: null,
});

function patientRoisReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_PATIENT_ROIS:
			return state.set('loading', true).set('error', null);
		case FETCH_PATIENT_ROIS_SUCCESS:
			return state.set('rois', fromJS(action.data)).set('loading', false);
		case FETCH_PATIENT_ROIS_ERROR:
			return state.set('error', action.err).set('loading', false);

		case REVOKE_PATIENT_ROI:
			return state.set('revoking', true).set('error', null);
		case REVOKE_PATIENT_ROI_SUCCESS: {
			const rois = state.get('rois').toJS();
			const updated = rois.map((r) =>
				r.id === action.data.id ? { ...r, status: 'revoked' } : r,
			);
			return state
				.set('rois', fromJS(updated))
				.set('revoking', false);
		}
		case REVOKE_PATIENT_ROI_ERROR:
			return state.set('error', action.err).set('revoking', false);

		case RENEW_PATIENT_ROI:
			return state.set('renewing', true).set('error', null);
		case RENEW_PATIENT_ROI_SUCCESS:
			return state.set('renewing', false);
		case RENEW_PATIENT_ROI_ERROR:
			return state.set('error', action.err).set('renewing', false);

		default:
			return state;
	}
}

export default patientRoisReducer;
